import * as yup from "yup";

export const createValidationSchema = yup.object().shape({
  username: yup
    .string()
    .min(3, "Tên đăng nhập phải có ít nhất 3 ký tự")
    .required("Vui lòng nhập tên đăng nhập"),
  password: yup
    .string()
    .min(8, "Mật khẩu phải có ít nhất 8 ký tự")
    .matches(/[A-Z]/, "Mật khẩu phải chứa ít nhất 1 chữ hoa")
    .matches(/[\W_]/, "Mật khẩu phải chứa ít nhất 1 ký tự đặc biệt")
    .required("Vui lòng nhập mật khẩu"),
  fullname: yup.string().required("Vui lòng nhập họ và tên"),
  phone: yup
    .string()
    .matches(/(84|0[3|5|7|8|9])+([0-9]{8})\b/, "Số điện thoại không hợp lệ")
    .required("Vui lòng nhập số điện thoại"),
  roles: yup
    .array()
    .of(yup.string())
    .min(1, "Vui lòng chọn ít nhất 1 quyền")
    .required("Vui lòng chọn quyền"),
});

// Backward compatibility export
export const validationSchema = createValidationSchema;

